import { render } from "./RiControlRestart.vue?vue&type=template&id=ec50bc02"
import script from "./RiControlRestart.vue?vue&type=script&lang=js"
export * from "./RiControlRestart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiControlRestart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec50bc02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec50bc02', __exports__)) {
    api.reload('ec50bc02', __exports__)
  }
  
  module.hot.accept("./RiControlRestart.vue?vue&type=template&id=ec50bc02", () => {
    api.rerender('ec50bc02', render)
  })

}


export default __exports__